<template>
  <div>
    <!-- <j-title-header :options="opsi"/> -->
    <div v-show="load_first">
      <!-- <b-row>
        <b-col cols="9">
          <div class="float-to-left">
            <jImportRules @upload-done="refreshTable"/>
          </div>
          <div>
            <div class="float-to-left">
              <jExportRules class="m__t--20" />
            </div>
          </div>

        </b-col>

        <b-col>
          <div class="create-flow">
            <b-button
              class="btn blue"
              @click="createRules">CREATE RULES</b-button>
          </div>
        </b-col>
      </b-row> -->

      <v-server-table
        ref="rulesServer"
        :url="env"
        :columns="columns"
        :options="options"
        class="jTable"
        @loading="loading"
        @loaded="loaded"
        @row-click="rowClick"
        @pagination="removeRowBackground">

        <div
          slot="beforeFilter"
          class="custom-search">
          <b-form
            inline
            @keypress.13.prevent="filter(filter_data)">
            <b-button
              class="btn grey btn-import-form m__r--5"
              @click="createRules">
              <i class="fa fa-plus fa-lg"/> Add
            </b-button>
            <j-select
              v-model="select_type"
              :disabled="false"
              :options="options_search"
              class="m__r--5"/>
            <b-form-input
              ref="filterInput"
              v-model="filter_data"
              placeholder="search"
              class="m__r--5"/>
            <b-button
              class="btn grey btn-import-form m__r--10"
              @click="filter(filter_data)">
              <i class="fa fa-search bold" /> Search
            </b-button>
            <jImportRules @upload-done="refreshTable"/>
          </b-form>
          <!-- <b-row>
            <b-col cols="7">
              <b-form
                @keyup.enter="filter(filter_data)">
                <b-form-group>
                  <j-input
                    v-model="filter_data"/>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col
              class="p--1 p__l--2"
              style="align-self: center;"
              cols="5">
              <b-button
                class="btn blue outline"
                @click="filter(filter_data)"> <i class="fa fa-search bold" /> Search </b-button>
            </b-col>
          </b-row> -->
        </div>

        <div
          slot="flow"
          slot-scope="props">
          <div
            v-for="(flow, index) in props.row.flows"
            :class="{'light-blue-flow' : index % 2 === 0}"
            :key="index"
            class="flow-table flow-arrow">
            <i
              v-if="index === 0"
              class="fa fa-square"/>
            {{ flow.name }}
          </div>
        </div>

        <div
          slot="created_date"
          slot-scope="props">
          {{ props.row.created_date | moment("DD/MM/YYYY") }}
        </div>

      </v-server-table>
    </div>

    <div
      v-if="!load_first">
      <jLoadingTable/>
    </div>

    <!-- <j-progress-screen
      ref="ImportFile"
      :data-kirim="data_import"
      :url-api="url"
      :headers="headers"
      @finish="uploadDone"/> -->

    <!-- <div>
      <b-modal
        ref="modalRule"
        class="mod-form"
        centered>
        <h3 class="float-to-center c--red">
          Error Data
        </h3>
        <v-client-table
          v-if="error_data[0]"
          :data="error_data"
          :columns="column"
          :options="option"
          class="jTable">

          <div
            slot="ERROR"
            slot-scope="props">
            <div
              v-for="(err, index) in props.row.ERROR"
              :key="index">
              {{ err }}
            </div>
          </div>

        </v-client-table>
        <download-excel
          :data="error_data"
          class="float-to-right m__t--30"
          name="Rules-data-error.xls">
          <b-button class="btn green">
            Export Error
          </b-button>
        </download-excel>
      </b-modal>
    </div> -->
  </div>

</template>

<script>
import { mapState, mapActions } from 'vuex';
import { jRules } from '@/mixins/components/jojoflow/jRules';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';
import jProgressScreen from '@/components/progress-screen/jProgressScreen';
import Vue from 'vue';
// import jExportRules from './jExportRules';
import jImportRules from './jImportRules';

export default {
  components: {
    jLoadingTable,
    jProgressScreen,
    // jExportRules,
    jImportRules,
  },
  mixins: [jRules],
  data() {
    return {
      rowing: null,
      default_import: true,
      opsi: {
        icon: 'fa-user',
        main_title: 'RULES',
        opt_title: '',
      },
      data_import: null,
      is_finish: false,
      list_error: [],
      error_data: [],
      is_error: false,
      column: ['POSITION_ID_OWNER', 'RULES_NAME', 'FLOWS', 'ERROR'],
      option: {
        filterable: false,
        perPage: 5,
        perPageValues: [5, 10, 20, 50, 100],
      },
    };
  },
  computed: {
    ...mapState('jStoreRules', ['rules_table']),
    url() {
      const getEnv = 'jojoflow/rule/import/single';
      return getEnv;
    },
    headers() {
      const token = Vue.ls.get('Token');
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      return headers;
    },
  },
  watch: {
    rowing(newData, oldData) {
      if (oldData) {
        this.removeRowClick(oldData);
      }
      // this.rowing = null;
    },
    load_first(val) {
      if (val) {
        setTimeout(() => {
          this.$refs.filterInput.focus();
        }, 200);
      }
    },
    // data_import() {
    //   this.$refs.ImportFile.toggleIsVisible();
    // },
  },
  created() {
    // this.getListRules();
  },
  methods: {
    ...mapActions('jStoreRules', ['getListRules']),
    createRules() {
      this.$router.replace('/rules/new');
    },
    rowClick(data) {
      const elem = document.getElementsByClassName(`row-${data.row.id}`);
      elem[0].setAttribute('style', 'background-color: #b3e8f8;');
      this.rowing = data.row.id;
      this.$emit('row-click', data);
      this.$store.commit('jStoreFlows/setOpenRule');
    },
    removeRowClick(data) {
      // console.log(data);
      if (this.rowing) {
        const elem = document.getElementsByClassName(`row-${data}`);
        if (elem.length === 1) {
          elem[0].setAttribute('style', 'background-color: none;');
        }
      }
    },
    removeRowBackground() {
      if (this.rowing) {
        const elem = document.getElementsByClassName(`row-${this.rowing}`);
        if (elem.length === 1) {
          elem[0].setAttribute('style', 'background-color: none;');
        }
      }
      this.rowing = null;
      this.$emit('pagination');
    },

    refreshTable() {
      this.$refs.rulesServer.getData();
    },
  },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/flow-rule/rules/jRules.vue